/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetTrustdockVerifications200ResponseCompanyVerificationDocumentComparingData } from './get-trustdock-verifications200-response-company-verification-document-comparing-data';
// May contain unused imports in some cases
// @ts-ignore
import { GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInner } from './get-trustdock-verifications200-response-company-verification-document-records-inner';
// May contain unused imports in some cases
// @ts-ignore
import { GetTrustdockVerifications200ResponseCompanyVerificationDocumentResult } from './get-trustdock-verifications200-response-company-verification-document-result';

/**
 * 
 * @export
 * @interface GetTrustdockVerifications200ResponseCompanyVerificationDocument
 */
export interface GetTrustdockVerifications200ResponseCompanyVerificationDocument {
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseCompanyVerificationDocument
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseCompanyVerificationDocument
     */
    'publicId': string;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseCompanyVerificationDocument
     */
    'idForHelper': string;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseCompanyVerificationDocument
     */
    'state': GetTrustdockVerifications200ResponseCompanyVerificationDocumentStateEnum;
    /**
     * 
     * @type {GetTrustdockVerifications200ResponseCompanyVerificationDocumentResult}
     * @memberof GetTrustdockVerifications200ResponseCompanyVerificationDocument
     */
    'result': GetTrustdockVerifications200ResponseCompanyVerificationDocumentResult | null;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseCompanyVerificationDocument
     */
    'acceptedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseCompanyVerificationDocument
     */
    'plansSelectedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseCompanyVerificationDocument
     */
    'documentSubmittedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseCompanyVerificationDocument
     */
    'preparedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseCompanyVerificationDocument
     */
    'verifiedAt': string | null;
    /**
     * 
     * @type {GetTrustdockVerifications200ResponseCompanyVerificationDocumentComparingData}
     * @memberof GetTrustdockVerifications200ResponseCompanyVerificationDocument
     */
    'comparingData': GetTrustdockVerifications200ResponseCompanyVerificationDocumentComparingData;
    /**
     * 
     * @type {Array<GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInner>}
     * @memberof GetTrustdockVerifications200ResponseCompanyVerificationDocument
     */
    'records': Array<GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInner> | null;
}

export const GetTrustdockVerifications200ResponseCompanyVerificationDocumentStateEnum = {
    accepted: 'accepted',
    plansSelected: 'plans_selected',
    documentSubmitted: 'document_submitted',
    inProgress: 'in_progress',
    verified: 'verified'
} as const;

export type GetTrustdockVerifications200ResponseCompanyVerificationDocumentStateEnum = typeof GetTrustdockVerifications200ResponseCompanyVerificationDocumentStateEnum[keyof typeof GetTrustdockVerifications200ResponseCompanyVerificationDocumentStateEnum];


